<template>
<div>
  <div v-if="isSharePage">
    <shareHead></shareHead>
    <div class="shareheadoffset"></div>
  </div>

  <van-pull-refresh v-model="isLoading" @refresh="onRefresh" head-height="70">
    <div class="shareBtn" @click="shareBtn"></div>
    <liveDetail :sourceUrl="getSourceUrl" :baseInfo="baseInfo" ref="liveDetail"> </liveDetail>
  </van-pull-refresh>


</div>
</template>

<script>
import shareHead from "../act001/share/shareHead";
import {actConfig} from "../../js/activity/actConfig";
import {activity} from "../../js/activity/getInfo";
import {Toast} from "vant";
import {app} from "../../network/app/app";
import liveDetail from "./liveDetailCom";
import {shareActHome, shareWXInit} from "../../js/activity/share";
import {baseConfig} from "../../network/baseConfig";

export default {
  name: "liveCom",
  components:{
    shareHead,
    liveDetail
  },
  data(){
    return{
      isSharePage: true,
      baseInfo: null,
      isLoading: false,
    }
  },
  beforeDestroy() {
    console.log('live com beforeDestroy')
  },
  created() {
    //输入的参数
    console.log(this.$route.params)
    console.log(this.$route.query)
    console.log('live com created')
    if(this.$route.params.isApp=='app'){
      this.isSharePage = false
      app.enable()
    }else{
      this.isSharePage = true
      app.disable()
    }

    actConfig.getData().activityId = this.$route.params.actID  //3
    this.baseInfo = activity.getData()

    this.isLoading = false;

  },
  mounted() {
    Toast.loading({
      duration: 5000, // 持续展示 toast
      forbidClick: true,
      message: '加载中...',
    });
    this.getLiveDetail()
  },
  computed:{
    getTitleText(){
      return this.baseInfo.title
    },
    getSourceUrl(){
      return this.baseInfo.content
    }
  },
  methods:{
    shareBtn(){
      console.log('btn share click')
      // shareActHome(this.baseInfo.synopsis)
      app.shareWebDialog(
          baseConfig.makeShareUrl(`live/com/share/${actConfig.getData().activityId}`),
          actConfig.getData().activityTitle,
          // "2022年5月19日，中科院广州分院科普志愿者服务团多位专家学者为做好新时期中科院科学传播，进行全国科普讲解大赛。敬请收看！",
          this.baseInfo.process,
          actConfig.getData().activityLogo
      );
    },
    onRefresh() {
      this.getLiveDetail()
    },
    backHomeList(){
      this.$router.back()
    },

    getLiveDetail(){
      // 获取活动详情--无需token
      activity.getActDetail().then(baseInfo=>{
        this.baseInfo = baseInfo
        console.log(baseInfo)
        console.log("act link: "+ baseInfo.content)
        // this.images = baseInfo.mainImages
        actConfig.getData().activityTitle = baseInfo.title
        actConfig.getData().activityLogo = baseInfo.img

        if (this.isSharePage){
          shareWXInit(baseInfo.title,
              this.baseInfo.process,
              // "2022年5月19日，中科院广州分院科普志愿者服务团多位专家学者为做好新时期中科院科学传播，进行全国科普讲解大赛。敬请收看！",
              baseConfig.makeShareUrl(`live/com/share/${actConfig.getData().activityId}`),
              this.baseInfo.img)
        }

        Toast.clear()
        this.isLoading = false;
        let isLive = true
        if(baseInfo.videoStandard=='false'){
          isLive = false
        }
        this.$refs.liveDetail.resetLiveSourceUrl(baseInfo.content, isLive)
      }).catch(err=>{
        Toast.clear()
        this.isLoading = false;
        this.$myDialog({
          logo: 'fail',
          text: err.msg,
          btnOK: "重试",
          btnCancel: "取消",
          callBack: (state)=>{
            console.log('获取活动详情 callback='+state)
            if(state){
              this.getLiveDetail()
            }
          }
        });
      }).finally(()=>{})
    },


  }
}
</script>

<style scoped>
.offset{
  width: 100%;
  height: 130px;
  /*background-color: #ff8198;*/
}
.navBar{
  display: flex;
  height: 54px;
  line-height: 54px;
  text-align: center;
  color: #30353d;
  margin-bottom: 40px;
  /*box-shadow: 0 1px 1px rgba(100,100,100,.1);*/
}
.navBar .center{
  display: flex;
  flex: 1;
  font-size: 45px;
  height: 54px;
  line-height: 54px;
  text-align: center;
}
.navBar .center .title-item{
  flex: 1;
  width: 400px;
}
.navBar .center .title-item span{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}


.shareheadoffset{
  width: 100%;
  height: 130px;
}

.shareBtn{
  position: fixed;
  top: 68%;
  right: 0px;
  width: 100px;
  height: 100px;
  background-color:rgba(255,255,255,0.7);
  background-image: url("../../assets/act001/shareBtn.png");
  background-size: 100% 100%;
  border-radius: 10px;
  z-index: 20;
}
</style>